export const CSWFieldId = {
  Confirmation: 'confirmation',
  Dimension: 'size',
  DutiesAndTaxes: 'duties-and-taxes',
  ExternalFulfillmentService: 'external-fulfillment-service',
  Grams: 'grams',
  Kilograms: 'kilograms',
  InsuranceAmount: 'insurance-amount',
  InsuranceProvider: 'insurance-provider',
  Ounces: 'ounces',
  Package: 'package',
  PackageDescription: 'package-description',
  Presets: 'presets',
  Pickup: 'pickup',
  Pounds: 'pounds',
  ShipFrom: 'ship-from',
  ShippingService: 'shipping-service',
  Weight: 'weight',
};

export const SHIPMENT_DETAILS = {
  pasteAddress: 'paste-address-text-area',
};

export const getOrderDetailsFieldId = (fieldId) => `order-details-${fieldId}`;
